import { generalMessages } from 'src/utils/messages';
import {
    faHouse,
    faArrowUpRight,
    faCar,
    faChevronLeft,
    faClockRotateLeft,
    faCopy,
    faCreditCard,
    faEdit,
    faExpand,
    faPlus,
    faSidebarFlip,
    faSpinnerThird,
    faTrashAlt,
    faUser,
    faWavePulse,
    faSpinner,
    faArrowRightToArc,
    faArrowLeftToArc,
    faBus,
    faTruck,
    faExclamationTriangle,
    faCircleXmark,
    faCircleCheck,
    faQuestionCircle,
    faCamera,
    faCalendar,
    faClock,
    faTableList,
    faHouseBuilding,
    faWandMagicSparkles,
    faScrewdriverWrench,
    faKey,
    faChevronDown,
    faCog,
    faSensor,
    faRoadBarrier,
    faSquareParking,
    faCircleExclamation,
    faCameraCctv,
    faShop,
    faClipboardUser,
    faMicrochip,
    faTag,
    faLock,
    faMoneyBill,
    faShareNodes,
    faBuildingColumns,
    faUserGroup,
    faArrowDown,
    faMinus,
    faArrowTrendUp,
    faArrowTrendDown,
    faMoneyFromBracket,
    faCoin,
    faCloud,
    faComputerClassic,
    faPieChart,
    faCoins,
    faCircleEuro,
    faArrowUp,
    faCompress,
    faReceipt,
    faUpload,
    faInfinity,
    faCircle1,
    faHourglassStart,
    faSearch,
    faTable,
    faFilter,
    faFilterList,
    faTicketPerforated,
    faMessageLines,
    faEllipsis,
    faPlay,
    faVideo,
    faRotateRight,
    faPeopleGroup,
    faChargingStation,
    faMotorcycle,
    faWheelchair,
    faServer,
    faGears,
    faDatabase,
    faArrowLeftFromArc,
    faCloudArrowUp,
    faPrint,
} from '@fortawesome/pro-regular-svg-icons';

enum RangeOptions {
    WEEK = 'week',
    MONTH = 'month',
    QUARTER = 'quarter',
    YEAR = 'year',
    INDEFINITE = 'indefinite',
    CUSTOM = 'custom',
}

const rangeOptions = [
    { value: RangeOptions.WEEK, label: generalMessages.oneWeek },
    { value: RangeOptions.MONTH, label: generalMessages.oneMonth },
    { value: RangeOptions.QUARTER, label: generalMessages.threeMonths },
    { value: RangeOptions.YEAR, label: generalMessages.oneYear },
    { value: RangeOptions.INDEFINITE, label: generalMessages.indefinite },
    { value: RangeOptions.CUSTOM, label: generalMessages.custom },
];

const ICON_MAP = {
    DELETE: faTrashAlt,
    EDIT: faEdit,
    SIDE_PANEL: faSidebarFlip,
    COPY: faCopy,
    ADD: faPlus,
    EXPAND: faExpand,
    SPINNER: faSpinnerThird,
    STATIC_SPINNER: faSpinner,
    MEMBER: faUser,
    CLIENT: faCar,
    RESERVATION: faClockRotateLeft,
    SUBSCRIPTION: faCreditCard,
    WAVE_PULSE: faWavePulse,
    ARROW_UP_RIGHT: faArrowUpRight,
    BACK: faChevronLeft,
    ARROW_RIGHT_ARC: faArrowRightToArc,
    ARROW_LEFT_ARC: faArrowLeftToArc,
    ARROW_LEFT_FROM_ARC: faArrowLeftFromArc,
    BUS: faBus,
    TRUCK: faTruck,
    DANGER: faExclamationTriangle,
    X_MARK: faCircleXmark,
    CHECK: faCircleCheck,
    TABLE_LIST: faTableList,
    QUESTION: faQuestionCircle,
    CAMERA: faCamera,
    CALENDAR: faCalendar,
    TIME: faClock,
    RESIDENT: faHouseBuilding,
    SERVICE: faScrewdriverWrench,
    CUSTOM_TEMPLATE: faWandMagicSparkles,
    KEY: faKey,
    DOWN: faChevronDown,
    CARD: faCreditCard,
    CASH: faMoneyBill,
    COIN: faCoin,
    ONLINE: faShareNodes,
    BANK: faBuildingColumns,
    COG: faCog,
    HOME: faHouse,
    SENSOR: faSensor,
    ROAD_BARRIER: faRoadBarrier,
    SQUARE_PARKING: faSquareParking,
    CIRCLE_EXCLAMATION: faCircleExclamation,
    CCTV_CAMERA: faCameraCctv,
    USERS: faUserGroup,
    MEMBERSHIP_CARD: faClipboardUser,
    MEMBERSHIP_CHIP: faMicrochip,
    MEMBERSHIP_TAG: faTag,
    PASSWORD: faLock,
    SHOP: faShop,
    PAY_STATION: faMoneyFromBracket,
    CLOUD: faCloud,
    HARDWARE: faComputerClassic,
    TREND_UP: faArrowTrendUp,
    TREND_DOWN: faArrowTrendDown,
    TRIANGLE_EXCLAMATION: faExclamationTriangle,
    PIE_CHART: faPieChart,
    TABLE: faTable,
    FILTER: faFilter,
    FILTER_LIST: faFilterList,
    MINUS: faMinus,
    ARROW_UP: faArrowUp,
    ARROW_DOWN: faArrowDown,
    CIRCLE_EURO: faCircleEuro,
    COINS: faCoins,
    COMPRESS: faCompress,
    SEARCH: faSearch,
    RECEIPT: faReceipt,
    PUBLISH: faUpload,
    FOREVER: faInfinity,
    SINGLE: faCircle1,
    TIME_SENSITIVE: faHourglassStart,
    TICKET_PERFORATED: faTicketPerforated,
    PEOPLE_GROUP: faPeopleGroup,
    PLAY: faPlay,
    VIDEO: faVideo,
    RETRY: faRotateRight,
    MESSAGE: faMessageLines,
    ELLIPSIS: faEllipsis,
    EV: faChargingStation,
    MOTORCYCLE: faMotorcycle,
    DISABLED: faWheelchair,
    BACKEND_HTTP_SERVICE: faServer,
    BACKEND_WORKER_SERVICE: faGears,
    BACKEND_INFRA_SERVICE: faDatabase,
    PRINTER: faPrint,
    UPLOAD: faCloudArrowUp,
};

export { rangeOptions, RangeOptions, ICON_MAP };

export const booleanBadgeOptions = {
    true: {
        label: generalMessages.yes,
        theme: 'green',
        icon: ICON_MAP.CHECK,
    },
    false: {
        label: generalMessages.no,
        theme: 'red',
        icon: ICON_MAP.X_MARK,
    },
};

export const BOOLEAN_MAP = {
    true: generalMessages.yes,
    false: generalMessages.no,
};

export const BOOLEAN_OPTIONS = ['true', 'false'];
